/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'rate-star': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M16 4a.8.8 0 00-.718.446l-3.522 7.137-7.875 1.143a.8.8 0 00-.444 1.365l5.7 5.555-1.346 7.845a.8.8 0 001.16.843L16 24.63l7.044 3.704a.8.8 0 001.161-.843l-1.346-7.845 5.7-5.555a.8.8 0 00-.444-1.364l-7.876-1.144-3.522-7.137A.8.8 0 0016 4zm0 2.608l2.99 6.06a.8.8 0 00.603.438l6.688.97-4.84 4.718a.8.8 0 00-.23.708l1.143 6.662-5.982-3.146a.8.8 0 00-.745 0l-5.981 3.145 1.142-6.661a.8.8 0 00-.23-.708L5.72 14.077l6.687-.971a.8.8 0 00.603-.438l2.99-6.06z" _fill="#747986"/>'
  }
})
